import i18n from '@/i18n'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/program/vip')({
  loader: async () => {
    await i18n.loadNamespaces('program/vip')
    return
  },
})
